import {FormControl, FormField} from 'platform/components';
import {Grid, GridItem, Show} from 'platform/foundation';

import i18n from '@dms/i18n';

import {FormValues} from '../types/FormValues';

interface UserInfoProps {
  control: FormControl<FormValues>;
  isCreating: boolean;
}

export function UserInfo(props: UserInfoProps) {
  return (
    <Grid columns={2}>
      <FormField
        control={props.control}
        type="text"
        name="firstName"
        label={i18n.t('general.labels.firstName')}
        isRequired
      />

      <FormField
        control={props.control}
        type="text"
        name="lastName"
        label={i18n.t('general.labels.lastName')}
        isRequired
      />

      <Show when={props.isCreating}>
        <GridItem span={2}>
          <FormField
            control={props.control}
            type="text"
            name="email"
            label={i18n.t('general.labels.email')}
            isRequired
          />
        </GridItem>

        <FormField
          control={props.control}
          type="password"
          name="password"
          label={i18n.t('general.labels.password')}
          isRequired
        />

        <FormField
          control={props.control}
          type="password"
          name="confirmPassword"
          label={i18n.t('general.labels.confirmPassword')}
          isRequired
        />
      </Show>
    </Grid>
  );
}
